// extracted by mini-css-extract-plugin
export default {"paginations":"Pagination_paginations__l5+RN"};